import type { PublicBuildingState as BuildingState } from "@point/core";
import { isoToScreen } from "./iso.ts";
import { BP } from "./theme.ts";

const NEIGHBOR_MAX = 3.9;
const NEIGHBOR_MIN = 0.25;

function roadKey(i: number, j: number): string {
	return i < j ? `${i}-${j}` : `${j}-${i}`;
}

export function CityRoads({ buildings }: { buildings: BuildingState[] }) {
	const segs: { x1: number; y1: number; x2: number; y2: number }[] = [];
	const seen = new Set<string>();

	for (let i = 0; i < buildings.length; i++) {
		for (let j = i + 1; j < buildings.length; j++) {
			const a = buildings[i];
			const b = buildings[j];
			if (!a || !b) continue;
			const dx = a.gridPos[0] - b.gridPos[0];
			const dz = a.gridPos[1] - b.gridPos[1];
			const dist = Math.hypot(dx, dz);
			if (dist < NEIGHBOR_MIN || dist > NEIGHBOR_MAX) continue;
			const key = roadKey(i, j);
			if (seen.has(key)) continue;
			seen.add(key);
			const p1 = isoToScreen(a.gridPos[0], a.gridPos[1]);
			const p2 = isoToScreen(b.gridPos[0], b.gridPos[1]);
			segs.push({ x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y });
		}
	}

	return (
		<g className="bp-roads">
			{segs.map((s) => (
				<line key={`${s.x1}:${s.y1}:${s.x2}:${s.y2}`} x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2} stroke={BP.road} strokeWidth={1} strokeLinecap="round" />
			))}
		</g>
	);
}
